import React, { Component } from 'react';
import {
  SurveyResult,
  Survey,
  SurveyWelcome,
  SurveyComments,
  SurveyComplete,
  RequestAssistance,
  SurveyReport,
  LearnMore,
  SurveyReportPresentation,
  OtherSuggestion,
  Surveys,
  Schools,
  Register,
  Dashboard,
  ActionPlan,
  MultiSurveyDashboard,
  ManagementStandards,
  GroupManagementStandards,
  ForgotPasswordForm,
  ResetPasswordForm,
  HeadTeacherSurveyResult,
  SuperAdminDashboard,
  SchoolDetails,
  Account,
  HeadTeacherCommentsReply,
  StaffCommentReply,
  StaffResults,
  StaffRoleHeatmap,
  VoiceDashboard,
  WelbeeVoice,
  HeadteacherVoiceConversation,
  StaffVoiceConversation,
  SurveyVoiceStaffReply,
  VoiceUpgrade,
  StaffManagement,
  WelbeeVoiceNotification,
  GroupDashboard,
  StaffRegister,
  AdminDashboard,
  SchoolDetailForm,
  SurveyWithVoiceSchoolRegistration,
  OnlyVoiceSchoolRegistration,
  MatAccounts,
  RegisterDirector,
  MatSchools,
  MatHeatMap,
  MatPresentation,
  AccountRegistrations,
  NotSubscribed,
  AdditionalQuestions,
  Invoices,
  SentEmails,
  Analytics,
  MatStaff,
  MATAnalytics,
  MatAdditionalQuestions,
  MatReport,
  SummaryReport,
  FilterLibrary,
  HomeRedirect,
  QuestionBankDashboard,
  EmailLogs,
  EmailTemplates,
  SendSetPasswordLinkUtility,
  SuperManagement,
  AuditLog,
} from '../views';

import { SuperAdminLanding } from '../auth';

import ThankYouMessage from '../components/common/ThankYouMessage';
import NotFound from '../views/PageNotFound/NotFound';
import SubscriptionNotAvailable from '../views/schoolSubscriptions/SubscriptionNotAvailable';
import MatCycles from '../views/mat/matCycle/MatCycles';
import DetailCycle from '../views/mat/matCycle/DetailCycle';
import SchoolSubscriptions from '../views/superAdmin/SchoolSubscriptions';
import AccountSubscription from '../views/account/AccountSubscription';
import MatAccount from '../views/mat/matAccount/MatAccount';
import SchoolListing from '../views/school/SchoolListing';
import RegisterSchool from '../views/school/register-school';
import GroupListing from '../views/mat/GroupListing';
import RegisterGroup from '../views/mat/register-group';
import EditGroup from '../views/mat/edit-group';
import EditSchoolWizard from '../views/school/edit-school';
import SearchResult from '../views/searchResult/SearchResult';
import SchoolDetail from '../views/school/SchoolDetail';
import GroupDetail from '../views/mat/GroupDetail';
import EditSubscription from '../views/Subscription/EditSubscription';
import EditSubscriptionSchool from '../views/Subscription/EditSubscriptionSchool';
import SubscriptionList from '../views/Subscription/SubscriptionList';
import UpcomingRenewals from '../views/Subscription/UpcomingRenewals';
import SurveyTemplatesDashboard from '../views/insights/surveyTemplates/SurveyTemplatesDashboard';
import ConversationAnalytics from '../components/aiUsage/ConversationAnalytics';

const routesObj = {
  Root: {
    path: '/',
    component: <SuperAdminLanding />,
    roles: [],
    fallback: null,
  },
  NotSubscribed: {
    path: '/not-subscribed',
    component: <NotSubscribed />,
    roles: [],
    fallback: null,
  },
  SurveyWelcome: {
    path: '/survey-welcome',
    component: <SurveyWelcome />,
    roles: [],
    fallback: null,
  },
  SurveyResult: {
    path: '/survey-result',
    component: <SurveyResult />,
    roles: [],
    fallback: null,
  },
  Survey: {
    path: '/survey',
    component: <Survey />,
    roles: [],
    fallback: null,
  },
  SurveyComplete: {
    path: '/survey-complete',
    component: <SurveyComplete />,
    roles: [],
    fallback: null,
  },
  SurveyComments: {
    path: '/survey-comments',
    component: <SurveyComments />,
    roles: [],
    fallback: null,
  },
  SurveyReport: {
    path: '/survey-report',
    component: <SurveyReport />,
    roles: [],
    fallback: null,
  },
  RequestAssistance: {
    path: '/request-assistance',
    component: <RequestAssistance />,
    roles: [],
    fallback: null,
  },
  SurveyUserGuide: {
    path: '/user-guide',
    roles: [],
    fallback: null,
  },
  StaffPresentation: {
    path: '/staff-presentation',
    component: <SurveyReportPresentation />,
    roles: [],
    fallback: null,
  },
  OtherSuggestion: {
    path: '/other-suggestion',
    component: <OtherSuggestion />,
    roles: [],
    fallback: null,
  },
  Schools: {
    path: '/schools',
    component: <Schools />,
    roles: [],
    fallback: null,
  },
  SchoolSurveyList: {
    path: '/school-surveys',
    component: <Surveys />,
    roles: [],
    fallback: null,
  },
  // Register: {
  //   path: '/school-register',
  //   component: <SchoolRegisterNew />,
  //   roles: [],
  //   fallback: null,
  // },
  StaffRegister: {
    path: '/staff-register',
    component: <StaffRegister />,
    roles: [],
    fallback: null,
  },
  ThankYouMessage: {
    path: '/thankyou-message',
    component: <ThankYouMessage />,
    roles: [],
    fallback: null,
  },
  Dashboard: {
    path: '/dashboard',
    component: <Dashboard />,
    roles: [],
    fallback: null,
  },
  MultiSurveyDashboard: {
    path: '/multi-survey-dashboard',
    component: <MultiSurveyDashboard />,
    roles: [],
    fallback: null,
  },
  ActionPlan: {
    path: '/action-plan',
    component: <ActionPlan />,
    roles: [],
    fallback: null,
  },
  ManagementStandards: {
    path: '/management-standards',
    component: <ManagementStandards />,
    roles: [],
    fallback: null,
  },
  GroupManagementStandards: {
    path: '/group-management-standards',
    component: <GroupManagementStandards />,
    roles: [],
    fallback: null,
  },
  ForgotPassword: {
    path: '/forgot-password',
    component: <ForgotPasswordForm />,
    roles: [],
    fallback: null,
  },
  ResetPassword: {
    path: '/reset-password',
    component: <ResetPasswordForm />,
    roles: [],
    fallback: null,
  },
  HeadTeacherSurveyResult: {
    path: '/head-teacher-survey-result',
    component: <HeadTeacherSurveyResult />,
    roles: [],
    fallback: null,
  },
  SuperAdminDashboard: {
    path: '/super-admin-dashboard',
    component: <SuperAdminDashboard />,
    roles: [],
    fallback: null,
  },
  Invoices: {
    path: '/Invoices',
    component: <Invoices />,
    roles: [],
    fallback: null,
  },
  SentEmails: {
    path: '/sent-emails',
    component: <SentEmails />,
    roles: [],
    fallback: null,
  },
  emailLogs: {
    path: '/sent-emails-logs',
    component: <EmailLogs />,
    roles: [],
    fallback: null,
  },
  emailTemplates: {
    path: '/email-templates',
    component: <EmailTemplates />,
    roles: [],
    fallback: null,
  },
  SchoolDetails: {
    path: '/school-details',
    component: <SchoolDetails />,
    roles: [],
    fallback: null,
  },
  Account: {
    path: '/account',
    component: <Account />,
    roles: [],
    fallback: null,
  },
  SurveyCommentsReply: {
    path: '/staff-comments-reply',
    component: <StaffCommentReply />,
    roles: [],
    fallback: null,
  },
  HeadTeacherCommentsReply: {
    path: '/head-teacher-reply',
    component: <HeadTeacherCommentsReply />,
    roles: [],
    fallback: null,
  },
  StaffResults: {
    path: '/staff-results',
    component: <StaffResults />,
    roles: [],
    fallback: null,
  },
  StaffRoleHeatmap: {
    path: '/staff-role-heatmap',
    component: <StaffRoleHeatmap />,
    roles: [],
    fallback: null,
  },
  VoiceDashboard: {
    path: '/voice-dashboard',
    component: <VoiceDashboard />,
    roles: [],
    fallback: null,
  },
  WelbeeVoice: {
    path: '/welbee-voice',
    component: <WelbeeVoice />,
    roles: [],
    fallback: null,
  },
  HeadteacherVoiceConversation: {
    path: '/headteacher-voice-conversation',
    component: <HeadteacherVoiceConversation />,
    roles: [],
    fallback: null,
  },
  StaffVoiceConversation: {
    path: '/staff-voice-conversation',
    component: <StaffVoiceConversation />,
    roles: [],
    fallback: null,
  },
  SurveyVoiceStaffReply: {
    path: '/survey-voice-staff-reply',
    component: <SurveyVoiceStaffReply />,
    roles: [],
    fallback: null,
  },
  VoiceUpgrade: {
    path: '/voice-upgrade',
    component: <VoiceUpgrade />,
    //roles: [],
    fallback: null,
  },
  VoiceUserGuide: {
    path: '/voice-instructions',
    roles: [],
    fallback: null,
  },
  StaffManagement: {
    path: '/staff-management',
    component: <StaffManagement />,
    roles: [],
    fallback: null,
  },
  WelbeeVoiceNotification: {
    path: '/welbee-voice-notification',
    component: <WelbeeVoiceNotification />,
    roles: [],
    fallback: null,
  },
  GroupDashboard: {
    path: '/group-dashboard',
    component: <GroupDashboard />,
    roles: [],
    fallback: null,
  },
  AdminDashboard: {
    path: '/admin-dashboard',
    component: <AdminDashboard />,
    roles: [],
    fallback: null,
  },
  SchoolDetailForm: {
    path: '/school-detail-form',
    component: <SchoolDetailForm />,
    // roles: [Roles.HeadTeacher, Roles.SuperAdmin],
    fallback: null,
  },
  SurveyFreeUrl: {
    path: '/register-survey-free',
    component: <OnlyVoiceSchoolRegistration />,
    fallback: null,
  },
  SurveyProUrl: {
    path: '/register-survey-pro',
    component: <SurveyWithVoiceSchoolRegistration />,
    fallback: null,
  },
  SurveyPremiumUrl: {
    path: '/register-survey-premium',
    component: <SurveyWithVoiceSchoolRegistration />,
    fallback: null,
  },
  VoiceFreeUrl: {
    path: '/register-voice-free',
    component: <OnlyVoiceSchoolRegistration />,
    fallback: null,
  },
  VoiceProUrl: {
    path: '/register-voice-pro',
    component: <SurveyWithVoiceSchoolRegistration />,
    fallback: null,
  },
  MatAccounts: {
    path: '/mat-accounts',
    component: <MatAccounts />,
    roles: [],
    fallback: null,
  },
  MatCycles: {
    path: '/mat-cycles',
    component: <MatCycles />,
    roles: [],
    fallback: null,
  },
  MatCycleDetail: {
    path: '/mat-cycle-detail',
    component: <DetailCycle />,
    roles: [],
    fallback: null,
  },
  RegisterDirector: {
    path: '/register-director',
    component: <RegisterDirector />,
    fallback: null,
  },
  MatSchools: {
    path: '/mat-schools',
    component: <MatSchools />,
    roles: [],
    fallback: null,
  },
  MatHeatMap: {
    path: '/mat-heat-map',
    component: <MatHeatMap />,
    roles: [],
    fallback: null,
  },
  MatPresentation: {
    path: '/mat-presentation',
    component: <MatPresentation />,
    roles: [],
    fallback: null,
  },
  MatReport: {
    path: '/mat-report',
    component: <MatReport />,
    roles: [],
    fallback: null,
  },
  SummaryReport: {
    path: '/summary-report',
    component: <SummaryReport />,
    roles: [],
    fallback: null,
  },
  MatStaffManagement: {
    path: '/mat-staff',
    component: <MatStaff />,
    roles: [],
    fallback: null,
  },
  MatAccount: {
    path: '/mat-account',
    component: <MatAccount />,
    roles: [],
    fallback: null,
  },
  AccountRegistrations: {
    path: '/account-registrations',
    component: <AccountRegistrations />,
    roles: [],
    fallback: null,
  },
  AdditionalQuestions: {
    path: '/additional-questions',
    component: <AdditionalQuestions />,
    roles: [],
    fallback: null,
  },
  SubscriptionNotAvailable: {
    path: '/subscription-not-available',
    component: <SubscriptionNotAvailable />,
    roles: [],
    fallback: null,
  },
  SchoolSubscriptions: {
    path: '/SchoolSubscriptions',
    component: <SchoolSubscriptions />,
    roles: [],
    fallback: null,
  },
  SchoolAnalytics: {
    path: '/Analytics',
    component: <Analytics />,
    roles: [],
    fallback: null,
  },
  AccountSubscription: {
    path: '/Account-Subscription',
    component: <AccountSubscription />,
    roles: [],
    fallback: null,
  },
  MATAnalytics: {
    path: '/mat-analytics',
    component: <MATAnalytics />,
    roles: [],
    fallback: null,
  },
  MatAdditionalQuestions: {
    path: '/mat-question-bank',
    component: <MatAdditionalQuestions />,
    roles: [],
    fallback: null,
  },
  FilterLibrary: {
    path: '/filter-library',
    component: <FilterLibrary />,
    roles: [],
    fallback: null,
  },
  HomeRedirect: {
    path: '/home-redirect',
    component: <HomeRedirect />,
    roles: [],
    fallback: null,
  },
  NotFound: {
    component: <NotFound />,
    fallback: null,
  },

  SchoolListing: {
    path: '/school-listing',
    component: <SchoolListing />,
    roles: [],
    fallback: null,
  },
  GroupListing: {
    path: '/Group-listing',
    component: <GroupListing />,
    roles: [],
    fallback: null,
  },
  RegisterGroup: {
    path: '/register-group',
    component: <RegisterGroup />,
    roles: [],
    fallback: null,
  },
  EditGroup: {
    path: '/edit-group',
    component: <EditGroup />,
    roles: [],
    fallback: null,
  },
  EditSchool: {
    path: '/edit-school',
    component: <EditSchoolWizard />,
    roles: [],
    fallback: null,
  },
  RegisterSchool: {
    path: '/register-school',
    component: <RegisterSchool />,
    roles: [],
    fallback: null,
  },
  SearchResult: {
    path: '/search-result',
    component: <SearchResult />,
    roles: [],
    fallback: null,
  },

  SchoolDetail: {
    path: '/school-detail',
    component: <SchoolDetail />,
    roles: [],
    fallback: null,
  },


  GroupDetail: {
    path: '/group-detail',
    component: <GroupDetail />,
    roles: [],
    fallback: null,
  },

  EditSubscription: {
    path: '/edit-subscription',
    component: <EditSubscription />,
    roles: [],
    fallback: null,
  },
  EditSubscriptionSchool: {
    path: '/edit-subscription-school',
    component: <EditSubscriptionSchool />,
    roles: [],
    fallback: null,
  },

  SubscriptionList: {
    path: '/subscription-list',
    component: <SubscriptionList />,
    roles: [],
    fallback: null,
  },
  UpcomingRenewals: {
    path: '/upcoming-renewals',
    component: <UpcomingRenewals />,
    roles: [],
    fallback: null,
  },

  InsightsQuestionBank: {
    path: '/insights-question-bank',
    component: <QuestionBankDashboard />,
    roles: [],
    fallback: null,
  },
  InsightsSurveyTemplates: {
    path: '/insights-survey-templates',
    component: <SurveyTemplatesDashboard />,
    roles: [],
    fallback: null,
  },
  SendSetPasswordLinkUtility: {
    path: '/admin/send-set-password-link',
    component: <SendSetPasswordLinkUtility />,
    roles: [],
    fallback: null,
  },
  SuperManagement: {
    path: '/super-management',
    component: <SuperManagement />,
    roles: [],
    fallback: null,
  },
  AuditLog: {
    path: '/audit-log',
    component: <AuditLog />,
    roles: [],
    fallback: null,
  },
  AiUsageAnalytics: {
    path: '/ai-usage-analytics',
    component: <ConversationAnalytics />,
    roles: [],
    fallback: null,
  },
};
export default routesObj;
